import React, { Component, createRef } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import Select from 'react-select';
import makeAnimated from 'react-select/animated';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleRight, faChevronDown } from '@fortawesome/free-solid-svg-icons';

import { errorHandler, getContent, getErrorMessage } from '../../../util/responseUtil';
import API_REPORT from '../../../api/apiReport';
import DateRange from '../../../components/DateRange/DateRange';
import ActionType from '../../../redux/reducer/globalActionType';
import Alert from '../../../components/Alert/Alert';
import MENU_REPORT from '../../../constants/menuReportConstant';
import TableNexcare from '../../../components/Table/TableNexcare';
import IconDownload from '../../../assets/icons/IconDownload';
import IconArrowUp from '../../../assets/icons/IconArrowUp';
import IconArrowDown from '../../../assets/icons/IconArrowDown';
import IconAddBlueBorder from '../../../assets/icons/IconAddBlueBorder';
import CreatableSelect from 'react-select/creatable';
import MasterDataUserAlert from '../../../components/MasterData/MasterDataUserAlert';
import { CheckPermissionComponent } from '../../../util/permission';
import {
    EXPORT_TICKET_INSERT,
    EXPORT_TICKET_PROFILE_UPDATE,
    EXPORT_TICKET_VIEW
} from '../../../constants/menuPermissionConstant';

const dataAllProfile = [
    { id: 1, label: "Nomor Tiket", fieldName: "TicketNo", checked: false },
    { id: 2, label: "Status", fieldName: "Status", checked: false },
    { id: 3, label: "Prioritas", fieldName: "Prioritas", checked: false },
    { id: 4, label: "Assign Tiket", fieldName: "AssignTicket", checked: false },
    { id: 5, label: "Nama Distributor", fieldName: "Distributor", checked: false },
    { id: 6, label: "Principal", fieldName: "Principal", checked: false },
    { id: 7, label: "PIC", fieldName: "Pic", checked: false },
    { id: 8, label: "Judul Keluhan", fieldName: "JudulKeluhan", checked: false },
    { id: 9, label: "Deskripsi Keluhan", fieldName: "DeskripsiKeluhan", checked: false },
    { id: 10, label: "Progress (%)", fieldName: "Progress", checked: false },
    { id: 11, label: "Pembuatan Tiket", fieldName: "DateCreatedTicket", checked: false },
    { id: 12, label: "Channel", fieldName: "ChannelTiket", checked: false },
    { id: 13, label: "Kategori Keluhan", fieldName: "IssueCategory", checked: false },
    { id: 14, label: "Kategori Penyebab Masalah", fieldName: "RootCause", checked: false },
    { id: 15, label: "Penyebab Masalah", fieldName: "PenyebabMasalah", checked: false },
    { id: 16, label: "Solusi", fieldName: "Solusi", checked: false },
    { id: 17, label: "Note", fieldName: "InternalNote", checked: false },
    { id: 18, label: "Tiket Dibuka", fieldName: "OpenTicket", checked: false },
    { id: 19, label: "Eskalasi ke CS Lain", fieldName: "EscalateToCs", checked: false },
    { id: 20, label: "Eskalasi ke CS Lead", fieldName: "EscalateToLead", checked: false },
    { id: 21, label: "Eskalasi ke Bug Validator", fieldName: "EscalateToBv", checked: false },
    { id: 22, label: "Eskalasi ke Pihak Ketiga", fieldName: "EscalateToExternal", checked: false },
    { id: 23, label: "Tiket Ditutup", fieldName: "ClosedTicket", checked: false },
    { id: 24, label: "Locked Tiket", fieldName: "LockedTicket", checked: false },
    { id: 25, label: "URL Link", fieldName: "UrlLink", checked: false },
    { id: 26, label: "Versi", fieldName: "VersiRilis", checked: false },
    { id: 27, label: "Nomor Redmine", fieldName: "NoBug", checked: false },
    { id: 28, label: "Kode NS", fieldName: "KodeNs", checked: false },
    { id: 29, label: "Kode Cabang", fieldName: "KodeCabang", checked: false },
    { id: 30, label: "Kode Distributor", fieldName: "KodeDistributor", checked: false },
    { id: 31, label: "Status Lisensi", fieldName: "StatusLisensi", checked: false },
    { id: 32, label: "Kategori Keluhan Distributor", fieldName: "KategoriKeluhanDistributor", checked: false },
    { id: 33, label: "Report Mapping", fieldName: "ReportMapping", checked: false },
    { id: 34, label: "Level CS", fieldName: "LevelCs", checked: false },
    { id: 35, label: "Point", fieldName: "Poin", checked: false },
    { id: 36, label: "Penilaian Tiket", fieldName: "PenilaianTiket", checked: false },
]
class ExportTicket extends Component {
    constructor(props) {
        super(props);
        this.state = {
            page: '1',
            report: {
                page: 1,
                limit: 10,
                data: [],
                value: 0,
                total: 0
            },
            principal: {
                page: 1,
                limit: 100,
                data: [],
                value: [],
                id: ''
            },
            status: {
                page: 1,
                limit: 10,
                data: [],
                value: []
            },
            priority: {
                page: 1,
                limit: 10,
                data: [],
                value: []
            },
            distributor: {
                page: 1,
                limit: 100,
                data: [],
                value: [],
                id: '',
            },
            distributorCodeArray: {
                page: 1,
                limit: 100,
                data: [],
                value: [],
                id: ''
            },
            fieldDate: {
                data: [
                    { value: "created_at", label: "Tanggal Tiket Dibuat" },
                    { value: "close_at", label: "Tanggal Tiket Ditutup" },
                ],
                value: { value: "created_at", label: "Tanggal Tiket Dibuat" },
            },
            showTicket: {
                data: [
                    { value: "F", label: "Tidak dihapus" },
                    { value: "T", label: "Telah dihapus" },
                    { value: "B", label: "Semua data" }
                ],
                value: { value: "F", label: "Tidak dihapus" },
            },
            showDateRange: false,
            isSubmitted: false,
            periodStart: '',
            periodEnd: '',
            showLoadMore: true,
            showConfirmAlertDownload: false,
            showConfirmAlertEmail: false,
            showSuccessAlert: false,
            showErrorAlert: false,
            showErrorAlertResponse: false,
            errorMessage: '',
            showLoadingPrincipal: false,
            showLoadingDistributor: false,
            showLoadingDistributorCodeArray: false,
            pagination: {
                current: 1,
                pageSize: 10,
                total: 0,
            },
            columns: [
                {
                    title: "Nama File",
                    dataIndex: "link_report",
                    headerAlign: "justify-start",
                    bodyAlign: "text-left",
                    render: (data) => `${data}`,
                },
                {
                    title: "Di Eksport Oleh",
                    dataIndex: "export_by",
                    headerAlign: "justify-start",
                    bodyAlign: "text-left",
                    render: (data) => `${data}`,
                },
                {
                    title: "Tanggal Di Eksport",
                    dataIndex: "created_at",
                    headerAlign: "justify-start",
                    bodyAlign: "text-left",
                    render: (data) => (moment.utc(data).format('DD/MM/YYYY HH:mm')),
                },
                {
                    title: "Progres",
                    dataIndex: "percentage",
                    headerAlign: "justify-start",
                    bodyAlign: "text-left",
                    render: (data) => `${data}%`,
                },
                {
                    title: "Aksi",
                    headerAlign: "justify-start",
                    bodyAlign: "text-left",
                    render: (data) => (
                        <div className={data.host !== '' && data.link_report !== '' ? "flex items-center justify-start" : "hidden"}>
                            <div className="w-7 h-7 flex justify-center items-center cursor-pointer">
                                <a href={data.host + data.link_report} target="_blank" rel="noreferrer" className="mx-1"><IconDownload /></a>
                            </div>
                        </div>
                    ),
                },
            ],
            listReportResult: [],
            checkedIndex: [],
            dataArrayRight: [],
            dataArrayLeft: [...dataAllProfile],
            email: {
                data: [],
                value: [],
                tempValue: '',
            },
            profileName: '',
            showConfirmAlertSaveNewProfile: false,
            showConfirmAlertSaveProfile: false,
            showSuccessAlertSaveProfile: false,
            showAlertProfileNameBlank: false,
            showAlertProfileNameExist: false,
            showConfirmAlertUpdateSaveProfile: false,
            showConfirmAlertExportTicket: false,
            showSuccessAlertUpdateSaveProfile: false,
            showSuccessAlertExportTicket: false,
            listDataProfile: {
                data: [],
                value: [],
            },
            dateFormat: {
                data: [
                    { value: "02/01/2006 03:04 PM", label: "DD/MMM/YYYY HH:MM AM/PM" },
                    { value: "02/01/2006 15:04", label: "DD/MMM/YYYY HH:MM" },
                    { value: "01/02/2006 03:04 PM", label: "MMM/DD/YYYY HH:MM AM/PM" },
                    { value: "01/02/2006 15:04", label: "MMM/DD/YYYY HH:MM" },
                    { value: "02-01-2006 03:04 PM", label: "DD-MMM-YYYY HH:MM AM/PM" },
                    { value: "02-01-2006 15:04", label: "DD-MMM-YYYY HH:MM" },
                    { value: "01-02-2006 03:04 PM", label: "MMM-DD-YYYY HH:MM AM/PM" },
                    { value: "01-02-2006 15:04", label: "MMM-DD-YYYY HH:MM" },
                    { value: "02/01/2006", label: "DD/MMM/YYYY" },
                    { value: "01/02/2006", label: "MMM/DD/YYYY" },
                    { value: "02-01-2006", label: "DD-MMM-YYYY" },
                    { value: "01-02-2006", label: "MMM-DD-YYYY" },
                ],
                value: { value: "02/01/2006 15:04", label: "DD/MMM/YYYY HH:MM" },
            },
            fileType: {
                data: [
                    { value: "csv", label: "CSV" }
                ],
                value: { value: "csv", label: "CSV" },
            }
        }
    }

    getDefaultValue = async () => {
        await this.setState({
            dataArrayRight: [],
            dataArrayLeft: [...dataAllProfile],
            distributor: {
                ...this.state.distributor,
                data: [],
                value: []
            },
            principal: {
                ...this.state.principal,
                data: [],
                value: []
            },
            status: {
                ...this.state.status,
                value: []
            },
            periodStart: '',
            periodEnd: '',
            priority: {
                ...this.state.priority,
                value: []
            },
            distributorCodeArray: {
                ...this.state.distributorCodeArray,
                id: '',
                data: [],
                value: []
            },
            showTicket: {
                ...this.state.showTicket,
                value: { value: "F", label: "Tidak dihapus" }
            },
            dateFormat: {
                ...this.state.dateFormat,
                value: { value: "02/01/2006 15:04", label: "DD/MMM/YYYY HH:MM" }
            },
            email: {
                ...this.state.email,
                value: []
            },
            listDataProfile: {
                ...this.state.listDataProfile,
                value: []
            },
            pagination: {
                ...this.state.pagination,
                page: 1
            }
        })
        this.getListPrincipal('');
        this.getListDistributorByMultiId('');
    }

    getListPrincipal = id => {
        this.setState({ showLoadingPrincipal: true });
        API_REPORT.getListPrincipalExportTicket(this.state.principal.page, this.state.principal.limit, id, this.props.token)
            .then(res => {
                let principalList = getContent(res).map(principal => ({
                    value: principal.user_nexcare_id,
                    label: principal.customer_name,
                    id: principal.id
                }))
                if (this._isMounted) {
                    this.setState({
                        principal: {
                            ...this.state.principal,
                            data: principalList
                        },
                        showLoadingPrincipal: false,
                    });
                }
            }).catch(errorHandler(this.props.handleLogout, this.props.history))
    }

    getSearchPrincipal = keyword => {
        this.setState({ showLoadingPrincipal: true });
        API_REPORT.getSearchPrincipalExportTicket(this.state.principal.page, this.state.principal.limit, keyword, this.state.distributor.id, this.props.token)
            .then(res => {
                let principalList = getContent(res).map(principal => ({
                    value: principal.user_nexcare_id,
                    label: principal.customer_name,
                    id: principal.id
                }))
                this.setState({
                    principal: {
                        ...this.state.principal,
                        data: principalList
                    },
                    showLoadingPrincipal: false,
                });
            }).catch(errorHandler(this.props.handleLogout, this.props.history))
    }

    getListDistributorByMultiId = id => {
        this.setState({ showLoadingDistributor: true });
        API_REPORT.getListDistributorByMultiIdExportTicket(this.state.distributor.page, this.state.distributor.limit, id, this.props.token)
            .then(res => {
                let distributorList = getContent(res).map(distributor => ({
                    value: distributor.user_nexcare_id,
                    label: distributor.customer_name,
                    id: distributor.id
                }))
                if (this._isMounted) {
                    this.setState({
                        distributor: {
                            ...this.state.distributor,
                            data: distributorList
                        },
                        showLoadingDistributor: false,
                    });
                }
            }).catch(errorHandler(this.props.handleLogout, this.props.history))
    }

    getListSearchDistributorByMultiId = keyword => {
        this.setState({ showLoadingDistributor: true });
        API_REPORT.getListSearchDistributorByMultiIdExportTicket(this.state.distributor.page, this.state.distributor.limit, keyword, this.state.principal.id, this.state.distributorCodeArray.id, this.props.token)
            .then(res => {
                let distributorList = getContent(res).map(distributor => ({
                    value: distributor.user_nexcare_id,
                    label: distributor.customer_name,
                    id: distributor.id
                }))
                if (this._isMounted) {
                    this.setState({
                        distributor: {
                            ...this.state.distributor,
                            data: distributorList
                        },
                        showLoadingDistributor: false,
                    });
                }
            }).catch(errorHandler(this.props.handleLogout, this.props.history))
    }

    getListDistributorCodeByMultiId = () => {
        this.setState({ showLoadingDistributorCodeArray: true });
        API_REPORT.getListDistributorCodeByMultiIdExportTicket(this.state.distributorCodeArray.page, this.state.distributorCodeArray.limit, this.state.principal.id, this.state.distributor.id, this.props.token)
            .then(res => {
                let distributorCodeList = getContent(res).map(distributorCode => ({
                    value: distributorCode.distributor_code,
                    label: distributorCode.distributor_code,
                    id: distributorCode.distributor_code
                }))
                if (this._isMounted) {
                    this.setState({
                        distributorCodeArray: {
                            ...this.state.distributorCodeArray,
                            data: distributorCodeList
                        },
                        showLoadingDistributorCodeArray: false,
                    });
                }
            }).catch(errorHandler(this.props.handleLogout, this.props.history))
    }

    getListSearchDistributorCodeByMultiId = keyword => {
        if (!this.state.principal.id && !this.state.distributor.id) {
            return this.setState({
                distributorCodeArray: {
                    ...this.state.distributorCodeArray,
                    data: [],
                    value: [],
                    id: ''
                }
            });
        }
        this.setState({ showLoadingDistributorCodeArray: true });
        API_REPORT.getListSearchDistributorCodeByMultiIdExportTicket(this.state.distributorCodeArray.page, this.state.distributorCodeArray.limit, this.state.principal.id, this.state.distributor.id, keyword, this.props.token)
            .then(res => {
                let distributorCodeList = getContent(res).map(distributorCode => ({
                    value: distributorCode.distributor_code,
                    label: distributorCode.distributor_code,
                    id: distributorCode.distributor_code
                }))
                if (this._isMounted) {
                    this.setState({
                        distributorCodeArray: {
                            ...this.state.distributorCodeArray,
                            data: distributorCodeList
                        },
                        showLoadingDistributorCodeArray: false,
                    });
                }
            }).catch(errorHandler(this.props.handleLogout, this.props.history))
    }

    getListDistributorByPrincipalAndDistributorCode = id => {
        this.setState({ showLoadingDistributor: true });
        API_REPORT.getListDistributorByPrincipalAndDistributorCodeExportTicket(this.state.distributor.page, this.state.distributor.limit, this.state.principal.id, id, this.props.token)
            .then(res => {
                let distributorList = getContent(res).map(distributor => ({
                    value: distributor.user_nexcare_id,
                    label: distributor.customer_name,
                    id: distributor.id
                }))
                if (this._isMounted) {
                    this.setState({
                        distributor: {
                            ...this.state.distributor,
                            data: distributorList
                        },
                        showLoadingDistributor: false,
                    });
                }
            }).catch(errorHandler(this.props.handleLogout, this.props.history))
    }

    getListPriority = () => {
        API_REPORT.getListPriorityExportTicket(this.state.status.page, this.state.status.limit, this.props.token)
            .then(res => {
                if (this._isMounted) {
                    this.setState({
                        priority: {
                            ...this.state.priority,
                            data: getContent(res)
                        }
                    });
                }
            }).catch(errorHandler(this.props.handleLogout, this.props.history))
    }

    getInitiateReport = () => {
        API_REPORT.getInitiateExportTicket(this.props.token)
            .then(res => {
                if (this._isMounted) {
                    this.setState({
                        report: {
                            ...this.state.report,
                            total: getContent(res).count_data
                        },
                        pagination: {
                            ...this.state.pagination,
                            total: getContent(res).count_data
                        }
                    })
                }
            }).catch(errorHandler(this.props.handleLogout, this.props.history))
    }

    getListReportResult = () => {
        API_REPORT.getListExportTicket(this.state.pagination.current, this.state.pagination.pageSize, this.props.token)
            .then(res => {
                if (this._isMounted) {
                    this.setState({
                        listReportResult: getContent(res)
                    });
                }
            }).catch(errorHandler(this.props.handleLogout, this.props.history))
    }

    getListProfileColumn = () => {
        API_REPORT.getListProfile(1, 100, this.props.token)
            .then(res => {
                let profileColumnList = getContent(res).map(profile => ({
                    value: profile,
                    label: profile.selection_name,
                }))
                if (this._isMounted) {
                    this.setState({
                        listDataProfile: {
                            ...this.state.listDataProfile,
                            data: profileColumnList
                        }
                    })
                }
            }).catch(errorHandler(this.props.handleLogout, this.props.history))
    }

    handleChangePrincipal = data => {
        this.setState({
            principal: {
                ...this.state.principal,
                value: data,
                id: this.convertIdMultiArrayToString(data),
            },
            distributor: {
                ...this.state.distributor,
                value: [],
                id: '',
            },
            distributorCodeArray: {
                ...this.state.distributorCodeArray,
                data: [],
                value: [],
                id: '',
            }
        },
            () => {
                setTimeout(() => {
                    if (!this.state.distributorCodeArray.id) {
                        this.getListDistributorByMultiId(this.state.principal.id);
                    }
                    if (this.state.principal.id) {
                        this.getListDistributorCodeByMultiId();
                    }
                }, 100);
            }
        )
    }

    handleChangeDistributor = data => {
        this.setState({
            distributor: {
                ...this.state.distributor,
                value: data,
                id: this.convertIdMultiArrayToString(data),
            },
            distributorCodeArray: {
                ...this.state.distributorCodeArray,
                data: [],
                value: [],
                id: '',
            }
        },
            () => {
                setTimeout(() => {
                    this.getListPrincipal(this.state.distributor.id)
                    this.getListDistributorCodeByMultiId()
                }, 100);
            }
        )
    }

    handleChangeDistributorCodeArray = data => {
        this.setState({
            distributorCodeArray: {
                ...this.state.distributorCodeArray,
                value: data,
                id: this.convertIdMultiArrayToString(data),
            },
        },
            () => {
                setTimeout(() => {
                    this.getListDistributorByPrincipalAndDistributorCode(this.state.distributorCodeArray.id)
                }, 100);
            }
        )
    }

    handleChangePriority = data => {
        this.setState({
            priority: {
                ...this.state.priority,
                value: data,
            }
        })
    }


    handleChangeStatus = data => {
        this.setState({
            status: {
                ...this.state.status,
                value: data
            }
        })
    }

    handleChangeFieldDate = data => {
        this.setState({
            fieldDate: {
                ...this.state.fieldDate,
                value: data,
            }
        })
    }

    handleChangeShowTicket = data => {
        this.setState({
            showTicket: {
                ...this.state.showTicket,
                value: data,
            }
        })
    }

    handleChangeDateFormat = data => {
        this.setState({
            dateFormat: {
                ...this.state.dateFormat,
                value: data,
            }
        })
    }

    handleChangeFileType = data => {
        this.setState({
            fileType: {
                ...this.state.fileType,
                value: data,
            }
        })
    }

    handleChangeProfile = data => {
        this.setState({
            listDataProfile: {
                ...this.state.listDataProfile,
                value: data,
            }
        }, () => {
            let selectedProfileColumn = this.state.listDataProfile.value.value.column_selection;
            let resultRightArray = [];
            for (const column of selectedProfileColumn) {
                if (!column.is_show) continue;
                let dataProfile = dataAllProfile.find((dap) => dap.fieldName === column.field_name);
                if (!dataProfile) continue;
                resultRightArray.push({
                    id: dataProfile.id,
                    label: dataProfile.label,
                    fieldName: dataProfile.fieldName,
                    checked: false
                })
            }
            let resultLeftArray = dataAllProfile.filter((el) => {
                let findData = selectedProfileColumn.findIndex((item) => {
                    return item.field_name === el.fieldName && item.is_show === true;
                });
                if (findData < 0) {
                    return el;
                }
                return null;
            });
            this.setState({
                dataArrayRight: resultRightArray,
                dataArrayLeft: resultLeftArray,
                dateFormat: {
                    ...this.state.dateFormat,
                    value: {
                        label: this.state.dateFormat.data.find(item => item.value === data.value.format_date).label,
                        value: data.value.format_date
                    }
                },
                fileType: {
                    ...this.state.fileType,
                    value: { value: "csv", label: "CSV" },
                },
                email: {
                    ...this.state.email,
                    value: data.value.email_to_average ? data.value.email_to_average.split(',').map(item => ({
                        label: item,
                        value: item
                    })) : ''
                }
            })
        })
    }

    getDateRange = (from, to) => {
        this.setState({
            periodStart: from,
            periodEnd: to
        })
    }

    resetDateRange = () => {
        this.setState({
            periodStart: '',
            periodEnd: ''
        })
    }

    handleDateRange = e => {
        if (this.dropdownRef && !this.dropdownRef.current.contains(e.target) && this.dateRangeRef && !this.dateRangeRef.current.contains(e.target)) {
            this.setState({
                showDateRange: false
            })
        }
    }

    convertIdMultiArrayToString = value => {
        let tempArrayId = value.map(data => { return data["id"] });
        return tempArrayId.join(",");
    }

    handleSelectedPage = currentPage => {
        this.setState(
            {
                pagination: {
                    ...this.state.pagination,
                    current: currentPage,
                },
            },
            () => {
                this.getListReportResult();
            }
        );
    };

    handleSelectedPageSize = currentPageSize => {
        this.setState(
            {
                pagination: {
                    ...this.state.pagination,
                    pageSize: currentPageSize,
                    current: 1,
                },
            },
            () => {
                this.getListReportResult();
            }
        );
    }

    handleCheck = (event, data, dataIndex) => {
        this.setState(prevState => ({
            dataArrayRight: prevState.dataArrayRight.map(
                obj => (obj.id === (data.id) ? Object.assign(obj, { ...this.state.dataArrayRight[dataIndex], checked: event.target.checked }) : obj)
            )
        }));
    }

    handleChangeEmail = event => {
        this.setState({ email: { ...this.state.email, tempValue: event } })
    }

    handleKeyDown = event => {
        if (event.key === "Enter" || event.key === "Tab") {
            this.setState(
                {
                    email:
                    {
                        ...this.state.email,
                        value: [...this.state.email.value, { value: this.state.email.tempValue + ";", label: this.state.email.tempValue }],
                        tempValue: '',
                    }
                })
        }
    }

    moveToLeft = (index) => {
        let tempMoveArray = this.state.dataArrayRight.splice(index, 1);
        for (let i in tempMoveArray) {
            tempMoveArray[i].checked = false;
        }
        let tempMergeTwoArray = [...this.state.dataArrayLeft, ...tempMoveArray];
        let sortMergeArray = tempMergeTwoArray.sort((a, b) => (a.id > b.id) ? 1 : ((b.id > a.id) ? -1 : 0));
        this.setState({ dataArrayRight: this.state.dataArrayRight, dataArrayLeft: sortMergeArray });
    }

    moveToRight = (index) => {
        let tempMoveArray = this.state.dataArrayLeft.splice(index, 1);
        this.setState({ dataArrayLeft: this.state.dataArrayLeft, dataArrayRight: [...this.state.dataArrayRight, ...tempMoveArray] });
    }

    moveAllToLeft = event => {
        if (!event.target.checked) {
            return
        }
        let tempMoveArray = this.state.dataArrayRight.splice(0, this.state.dataArrayRight.length);
        for (let i in tempMoveArray) {
            tempMoveArray[i].checked = false;
        }
        let tempMergeTwoArray = [...this.state.dataArrayLeft, ...tempMoveArray];
        let sortMergeArray = tempMergeTwoArray.sort((a, b) => (a.id > b.id) ? 1 : ((b.id > a.id) ? -1 : 0));
        this.setState({ dataArrayRight: this.state.dataArrayRight, dataArrayLeft: sortMergeArray });
    }

    moveAllToRight = event => {
        if (!event.target.checked) {
            return
        }
        let tempMoveArray = this.state.dataArrayLeft.splice(0, this.state.dataArrayLeft.length);
        this.setState({ dataArrayLeft: this.state.dataArrayLeft, dataArrayRight: [...this.state.dataArrayRight, ...tempMoveArray] });
    }

    moveUpOneStep = () => {
        let tempCheckedArray = this.state.dataArrayRight.map((data, index) => data.checked && index).filter(Number.isFinite);
        this.setState({
            checkedIndex: tempCheckedArray
        }, () => {
            let tempPopCheckedData = this.state.dataArrayRight.filter((data, index) => this.state.checkedIndex.includes(index));
            let tempDeletedArrayFromCheckedData = this.state.dataArrayRight.filter((data, index) => !this.state.checkedIndex.includes(index));
            let smallestIndex = 0;
            if (this.state.checkedIndex.length > 0) {
                smallestIndex = Math.min(...this.state.checkedIndex);
            }
            if (smallestIndex === 0) {
                return this.setState({
                    dataArrayRight: this.mergeTwoArrayByStartIndex(tempDeletedArrayFromCheckedData, tempPopCheckedData, smallestIndex)
                })
            }
            if (smallestIndex > 0) {
                return this.setState({
                    dataArrayRight: this.mergeTwoArrayByStartIndex(tempDeletedArrayFromCheckedData, tempPopCheckedData, smallestIndex - 1)
                })
            }
        });
    }

    moveDownOneStep = () => {
        let tempCheckedArray = this.state.dataArrayRight.map((data, index) => data.checked && index).filter(Number.isFinite);
        this.setState({
            checkedIndex: tempCheckedArray
        }, () => {
            let tempPopCheckedData = this.state.dataArrayRight.filter((data, index) => this.state.checkedIndex.includes(index));
            let tempDeletedArrayFromCheckedData = this.state.dataArrayRight.filter((data, index) => !this.state.checkedIndex.includes(index));
            let smallestIndex = 0;
            if (this.state.checkedIndex.length > 0) {
                smallestIndex = Math.min(...this.state.checkedIndex)
            }
            this.setState({
                dataArrayRight: this.mergeTwoArrayByStartIndex(tempDeletedArrayFromCheckedData, tempPopCheckedData, smallestIndex + 1)
            })
        });
    }

    mergeTwoArrayByStartIndex = (dataFrom, dataTo, startIndex) => {
        return [...dataFrom.slice(0, startIndex), ...dataTo, ...dataFrom.slice(startIndex)];
    }

    saveNewProfile = () => {
        if (this.state.dataArrayRight.length === 0) {
            return this.setState({
                showErrorAlertEmptyColumn: true,
                showConfirmAlertSaveProfile: false
            })
        }
        this.setState({ showConfirmAlertSaveProfile: false })

        let exportColumn = [];
        let indexArray = 0;
        for (let i in this.state.dataArrayRight) {
            let tempDataColumn = {
                field_name: this.state.dataArrayRight[i].fieldName,
                is_show: true,
                index: indexArray
            }
            exportColumn.push(tempDataColumn);
            indexArray++;
        }
        for (let i in this.state.dataArrayLeft) {
            let tempDataColumn = {
                field_name: this.state.dataArrayLeft[i].fieldName,
                is_show: false,
                index: indexArray
            }
            exportColumn.push(tempDataColumn);
            indexArray++;
        }

        const dateNow = new Date().toISOString();
        const data = {
            user_nexcare_id: this.props.userDetail.nexcare_id,
            type: "export ticket",
            selection_name: this.state.profileName,
            column_selection: exportColumn,
            format_date: this.state.dateFormat.value.value,
            file_type: "csv",
            email_to_average: this.state.email.value.length > 0 ? this.state.email.value.map(item => item.value.replace(';', '')) : [],
            created_client: this.props.userDetail.client_id,
            updated_client: this.props.userDetail.client_id,
            created_at: dateNow,
            created_by: this.props.userDetail.nexcare_id,
            updated_at: dateNow,
            updated_by: this.props.userDetail.nexcare_id,
        }

        API_REPORT.postNewProfile(data, this.props.token)
            .then(res => {
                this.setState({
                    showSuccessAlertSaveProfile: true,
                    profileName: '',
                })
                this.getListProfileColumn();
            }).catch(errorHandler(this.props.handleLogout, this.props.history, err => {
                this.setState({
                    errorMessage: getErrorMessage(err),
                    showErrorAlertResponse: true,
                })
            }))
    }

    updateProfile = () => {
        if (this.state.dataArrayRight.length === 0) {
            return this.setState({
                showErrorAlertEmptyColumn: true,
                showConfirmAlertUpdateSaveProfile: false
            })
        }
        this.setState({ showConfirmAlertUpdateSaveProfile: false });

        let exportColumn = [];
        let indexArray = 0;
        for (let i in this.state.dataArrayRight) {
            let tempDataColumn = {
                field_name: this.state.dataArrayRight[i].fieldName,
                is_show: true,
                index: indexArray
            }
            exportColumn.push(tempDataColumn);
            indexArray++;
        }
        for (let i in this.state.dataArrayLeft) {
            let tempDataColumn = {
                field_name: this.state.dataArrayLeft[i].fieldName,
                is_show: false,
                index: indexArray
            }
            exportColumn.push(tempDataColumn);
            indexArray++;
        }

        const dateNow = new Date().toISOString();
        const data = {
            user_nexcare_id: this.props.userDetail.nexcare_id,
            type: "export ticket",
            selection_name: this.state.listDataProfile.value.value.selection_name,
            column_selection: exportColumn,
            format_date: this.state.dateFormat.value.value,
            file_type: "csv",
            email_to_average: this.state.email.value.length > 0 ? this.state.email.value.map(item => item.value.replace(';', '')) : [],
            updated_client: this.props.userDetail.client_id,
            updated_at: dateNow,
            updated_by: this.props.userDetail.nexcare_id,
        }

        API_REPORT.updateProfile(this.state.listDataProfile.value.value.id, data, this.props.token)
            .then(res => {
                this.setState({
                    showSuccessAlertSaveProfile: true,
                })
                this.getListProfileColumn();
            }).catch(errorHandler(this.props.handleLogout, this.props.history, err => {
                this.setState({
                    errorMessage: getErrorMessage(err),
                    showErrorAlertResponse: true,
                })
            }))
    }

    validationProfileName = () => {
        if (!this.state.profileName) {
            this.setState({ showAlertProfileNameBlank: true, showAlertProfileNameExist: false, });
            return
        }

        if (this.state.listDataProfile.data.some(
            element => element.label.toLowerCase() === this.state.profileName.toLowerCase())
        ) {
            this.setState({ showAlertProfileNameExist: true, showAlertProfileNameBlank: false });
            return
        }

        this.setState({ showConfirmAlertSaveProfile: true, showConfirmAlertSaveNewProfile: false });
    }

    validationUpdateSaveProfile = () => {
        if (this.state.listDataProfile.value.value) {
            this.setState({ showConfirmAlertUpdateSaveProfile: true });
            return
        }
        this.setState({ showConfirmAlertSaveNewProfile: true })
    }

    saveNewProfileDescription = () => {
        return (
            <div className="text-left">
                <label>Nama Profile Kolom</label>
                <input type="text" placeholder="Tulis Nama Profile Kolom" className="form-control-second w-full" value={this.state.profileName} onChange={(e) => this.setState({ profileName: e.target.value })} />
                {this.state.showAlertProfileNameBlank && <MasterDataUserAlert text="Wajib diisi!" />}
                {this.state.showAlertProfileNameExist && <MasterDataUserAlert text="Data sudah pernah digunakan. Silakan masukkan nama profile kolom yang berbeda" />}
            </div>
        )
    }

    handleExportTicket = () => {
        if (this.state.isSubmitted) {
            return console.log('Data ini sudah pernah diproses!');
        }

        this.setState({ isSubmitted: true })

        let exportColumn = [];
        for (let i in this.state.dataArrayRight) {
            let tempDataColumn = {
                index: this.state.dataArrayRight[i].id - 1,
                field_name: this.state.dataArrayRight[i].fieldName,
                is_show: true,
            }
            exportColumn.push(tempDataColumn);
        }
        for (let i in this.state.dataArrayLeft) {
            let tempDataColumn = {
                index: this.state.dataArrayLeft[i].id - 1,
                field_name: this.state.dataArrayLeft[i].fieldName,
                is_show: false,
            }
            exportColumn.push(tempDataColumn);
        }
        // exportColumn.sort((a, b) => a.index - b.index);

        const data = {
            customer: this.state.distributor.value.map((data => ({ 'customer_id': data.value }))),
            principal_array: this.state.principal.value.map((data => data.value)),
            ticket_status: this.state.status.value.length > 0 ? this.state.status.value.map(data => ({ 'status_ticket': data.remark })) : [{ 'status_ticket': 'all' }],
            period_start: this.state.periodStart === '' ? '' : moment(this.state.periodStart).format('YYYY-MM-DD'),
            period_end: this.state.periodEnd === '' ? '' : moment(this.state.periodEnd).format('YYYY-MM-DD'),
            field_date: this.state.fieldDate.value.value,
            report_type: "export",
            report_option: "reportexport",
            priority: this.state.priority.value.map((data => data.remark)),
            distributor_code: this.state.distributorCodeArray.id ? this.state.distributorCodeArray.id.split(",") : [],
            format_date: this.state.dateFormat.value.value,
            ticket_deleted: this.state.showTicket.value.value,
            template_id: this.state.listDataProfile.value?.value?.id ? this.state.listDataProfile.value.value.id : 0,
            file_type: this.state.fileType.value.value,
            email_to_average: this.state.email.value.length > 0 ? this.state.email.value.map((data => data.value.split(';')[0])) : [],
            column_selection: exportColumn
        }

        API_REPORT.postExportTicket(data, this.props.token)
            .then(res => {
                this.getDefaultValue();
                this.getListReportResult();
                this.setState({
                    isSubmitted: false,
                    showSuccessAlert: true,
                    showConfirmAlertExportTicket: false,
                    page: '3'
                })
                setTimeout(() => this.setState({ showSuccessAlert: false }), 1500)
            }).catch(errorHandler(this.props.handleLogout, this.props.history, err => {
                this.setState({
                    isSubmitted: false,
                    errorMessage: getErrorMessage(err),
                    showErrorAlertResponse: true,
                    showConfirmAlertExportTicket: false
                })
            }))
    }

    componentDidMount() {
        this._isMounted = true;
        this.dropdownRef = createRef();
        this.dateRangeRef = createRef();

        this.getListPrincipal('');
        this.getListDistributorByMultiId('');
        this.setState({
            status: {
                ...this.state.status,
                data: MENU_REPORT.dataStatus
            }
        });
        this.getListPriority();
        this.getInitiateReport();
        this.intervalId = setInterval(() => this.getListReportResult(), 120000);
        this.getListReportResult();
        this.getListProfileColumn();
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.showDateRange !== this.state.showDateRange) {
            if (this.state.showDateRange) {
                document.addEventListener('click', this.handleDateRange)
            }
        }
    }

    componentWillUnmount() {
        this._isMounted = false;

        clearInterval(this.intervalId);
        document.removeEventListener('click', this.handleDateRange);
    }

    render() {
        const animatedComponents = makeAnimated();
        return (
            <CheckPermissionComponent permissionConstant={[EXPORT_TICKET_VIEW]} userPermission={this.props.userDetail.permissions}>
                <div className="space-y-3">
                    {/* BREADCRUMBS */}
                    <div className="flex items-center text-gray-500 space-x-2">
                        <div>Laporan</div>
                        <FontAwesomeIcon icon={faAngleRight} />
                        <div className="font-semibold">
                            {this.state.page === "1" && "Kriteria Eksport Tiket"}
                            {this.state.page === "2" && "Pemilihan Kolom Eksport Tiket"}
                            {this.state.page === "3" && "Hasil Eksport Tiket"}
                        </div>
                    </div>

                    {/* TITLE */}
                    <div className="flex items-center text-3xl font-bold space-x-4">
                        <div>
                            {this.state.page === "1" && "Kriteria Eksport Tiket"}
                            {this.state.page === "2" && "Pemilihan Kolom Eksport Tiket"}
                            {this.state.page === "3" && "Hasil Eksport Tiket"}
                        </div>
                    </div>

                    {/* WHITECONTAINER */}
                    <div className="pb-5">
                        <div className="calculate-layout-blank bg-white rounded-lg p-5 h-full">
                            {/* MENU HEADBAR */}
                            <div className="flex items-center space-x-5 text-2xl text-gray-700 px-2 pb-10">
                                <button className={this.state.page === "1" ? "active-menu-kms font-medium" : "font-medium"} onClick={() => this.setState({ page: '1' })}>
                                    Kriteria
                                </button>
                                <button className={this.state.page === "2" ? "active-menu-kms font-medium" : "font-medium"} onClick={() => this.setState({ page: '2' })}>
                                    Pemilihan Kolom
                                </button>
                                <button className={this.state.page === "3" ? "active-menu-kms font-medium" : "font-medium"} onClick={() => this.setState({ page: '3' })}>
                                    Hasil
                                </button>
                            </div>

                            {/* CRITERIA */}
                            <div className={this.state.page === "1" ? "flex h-full" : "hidden"}>
                                <div className="left w-1/4 p-2 overflow-y-auto">
                                    <div className="mb-3">
                                        <label>Principal</label>
                                        <Select
                                            isLoading={this.state.showLoadingPrincipal}
                                            inputId="ddsprincipal"
                                            closeMenuOnSelect={false}
                                            components={animatedComponents}
                                            isMulti
                                            placeholder="Pilih Principal"
                                            options={this.state.principal.data}
                                            value={this.state.principal.value}
                                            onChange={this.handleChangePrincipal}
                                            onInputChange={this.getSearchPrincipal}
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label>Distributor</label>
                                        <Select
                                            isLoading={this.state.showLoadingDistributor}
                                            inputId="ddscustomername"
                                            closeMenuOnSelect={false}
                                            components={animatedComponents}
                                            isMulti
                                            placeholder="Pilih Distributor"
                                            options={this.state.distributor.data}
                                            value={this.state.distributor.value}
                                            onChange={this.handleChangeDistributor}
                                            onInputChange={this.getListSearchDistributorByMultiId}
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label>Kode Distributor</label>
                                        <Select
                                            isLoading={this.state.showLoadingDistributorCodeArray}
                                            isMulti
                                            inputId="ddsdistributorcode"
                                            closeMenuOnSelect={false}
                                            placeholder="Pilih Kode Distributor"
                                            options={this.state.distributorCodeArray.data}
                                            value={this.state.distributorCodeArray.value}
                                            onChange={this.handleChangeDistributorCodeArray}
                                            onInputChange={this.getListSearchDistributorCodeByMultiId}
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label>Status</label>
                                        <Select
                                            inputId="ddlstatus"
                                            closeMenuOnSelect={false}
                                            components={animatedComponents}
                                            isMulti
                                            placeholder="Pilih Status"
                                            options={this.state.status.data}
                                            value={this.state.status.value}
                                            onChange={this.handleChangeStatus}
                                        />
                                    </div>
                                    <div className="mb-3 pb-2">
                                        <label>Prioritas</label>
                                        <Select
                                            isMulti
                                            inputId="ddlprioritas"
                                            closeMenuOnSelect={false}
                                            placeholder="Pilih Prioritas"
                                            value={this.state.priority.value}
                                            onChange={this.handleChangePriority}
                                            options={this.state.priority.data.map(data => ({ value: data.id, label: data.description, remark: data.remark }))}
                                        />
                                    </div>
                                    <div className="mb-3 relative">
                                        <label>Periode</label>
                                        <div className="form-control select-none" id="dplperiode" onClick={() => this.setState({ showDateRange: !this.state.showDateRange })} ref={this.dropdownRef} tabIndex="-1">
                                            {
                                                this.state.periodStart === '' || this.state.periodEnd === '' ?
                                                    <div className="flex justify-between items-center">
                                                        <div className="placeholder">Pilih Periode</div>
                                                        <FontAwesomeIcon icon={faChevronDown} className="select-icon" />
                                                    </div>
                                                    :
                                                    <div className="flex justify-between items-center">
                                                        <div>{moment(this.state.periodStart).format('DD/MM/YYYY')} - {moment(this.state.periodEnd).format('DD/MM/YYYY')}</div>
                                                        <FontAwesomeIcon icon={faChevronDown} className="select-icon" />
                                                    </div>
                                            }
                                        </div>
                                        <div className={this.state.showDateRange ? "bg-white absolute w-full mt-1 z-10" : "hidden"} ref={this.dateRangeRef}>
                                            <DateRange
                                                getDateRange={this.getDateRange}
                                                resetDateRange={this.resetDateRange}
                                                handleSave={() => this.setState({ showDateRange: !this.state.showDateRange })}
                                            />
                                        </div>
                                    </div>
                                    <div className="mb-3 pb-2">
                                        <label>Eksport Tiket Berdasarkan</label>
                                        <Select
                                            inputId="ddlfielddate"
                                            menuPlacement="auto"
                                            placeholder="Pilih Eksport Tiket Berdasarkan"
                                            value={this.state.fieldDate.value}
                                            onChange={this.handleChangeFieldDate}
                                            options={this.state.fieldDate.data}
                                        />
                                    </div>
                                    <div className="mb-3 pb-2">
                                        <label>Menampilkan Tiket</label>
                                        <Select
                                            inputId="ddlshowticket"
                                            menuPlacement="auto"
                                            placeholder="Pilih Menampilkan Tiket"
                                            value={this.state.showTicket.value}
                                            onChange={this.handleChangeShowTicket}
                                            options={this.state.showTicket.data}
                                        />
                                    </div>
                                </div>
                            </div>

                            {/* Column Selection */}
                            <div className={this.state.page === "2" ? "h-5/6 w-full space-y-5 overflow-auto p-2" : "hidden"}>
                                <div className="space-x-5 flex items-end">
                                    <div className="w-96">
                                        <label>Nama Profile Kolom</label>
                                        <Select
                                            inputId="ddsprofilename"
                                            components={animatedComponents}
                                            placeholder="Memilih Profile"
                                            value={this.state.listDataProfile.value}
                                            options={this.state.listDataProfile.data}
                                            onChange={this.handleChangeProfile}
                                        />
                                    </div>
                                    <CheckPermissionComponent permissionConstant={[EXPORT_TICKET_PROFILE_UPDATE]} userPermission={this.props.userDetail.permissions}>
                                        <button id="btnsaveprofile" className="border border-olddarkblue bg-transparent text-olddarkblue px-6 rounded font-medium min-h-38" onClick={() => this.validationUpdateSaveProfile()}>Simpan</button>
                                    </CheckPermissionComponent>
                                    <CheckPermissionComponent permissionConstant={[EXPORT_TICKET_INSERT]} userPermission={this.props.userDetail.permissions}>
                                        <button id="btnsaveasprofile" className="flex items-center cursor-pointer bg-olddarkblue text-white px-6 rounded min-h-38" onClick={() => this.setState({ showConfirmAlertSaveNewProfile: true })}>
                                            <IconAddBlueBorder />
                                            <span className="ml-1">Simpan Profile Baru</span>
                                        </button>
                                    </CheckPermissionComponent>
                                </div>

                                <div className="flex space-x-5 h-full text-lg">
                                    <div className="bg-gray-50 w-96 rounded-lg shadow-box-button">
                                        <div className="bg-darkbluegrey h-16 rounded-t-lg flex items-center p-3">
                                            <div>Kolom Untuk Dipilih</div>
                                        </div>
                                        <div className="overflow-auto h-96">
                                            <div className="flex w-full py-2 px-3 justify-between sticky top-0 bg-white">
                                                <label>Pilih Semua</label>
                                                <input id="btnselectallcolumns" type="checkbox" onChange={this.moveAllToRight} checked={this.state.dataArrayLeft.length > 0 ? false : true}></input>
                                            </div>
                                            {this.state.dataArrayLeft.map((data, index) =>
                                                <div key={`data-export-${data.id}`} className="flex w-full py-2 px-3 justify-between">
                                                    <label id="btnselectallcolumn" className="w-full cursor-pointer" onClick={() => this.moveToRight(index)}>{data.label}</label>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                    <div className="bg-gray-50 w-96 h-full rounded-lg shadow-box-button">
                                        <div className="bg-darkbluegrey h-16 rounded-t-lg flex items-center justify-between p-3">
                                            <div>Kolom Untuk Dieksport</div>
                                            {/* Button Move Up & Down */}
                                            <div className="flex flex-col text-darkblue">
                                                <button id="btnorderup" onClick={this.moveUpOneStep} className="mb-0.5"><IconArrowUp /></button>
                                                <button id="btnorderdown" onClick={this.moveDownOneStep}><IconArrowDown /></button>
                                            </div>
                                        </div>

                                        <div className="overflow-auto h-96">
                                            <div className="flex w-full py-2 px-3 justify-between sticky top-0 bg-white">
                                                <label>Batal Pilih Semua</label>
                                                <input id="btnunselectallcolumns" type="checkbox" onChange={this.moveAllToLeft} checked={this.state.dataArrayRight.length > 0 ? false : true}></input>
                                            </div>
                                            {this.state.dataArrayRight.map((data, index) =>
                                                <div key={`data-export-${data.id}`} className="flex w-full py-2 px-3 justify-between">
                                                    <label id="btnunselectcolumn" className="w-4/6 cursor-pointer" onClick={() => this.moveToLeft(index)}>{data.label}</label>
                                                    {/* Checklist for multiselect up & down */}
                                                    <input id="ckbselectcolumntosort" type="checkbox" name={data.label} value={data} onChange={(e) => this.handleCheck(e, data, index)} checked={data.checked}></input>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>

                                <div className="w-96">
                                    <label>Format Tanggal</label>
                                    <Select
                                        inputId="ddlformatdate"
                                        components={animatedComponents}
                                        placeholder="Pilih Format Tanggal"
                                        value={this.state.dateFormat.value}
                                        options={this.state.dateFormat.data}
                                        onChange={this.handleChangeDateFormat}
                                    />
                                </div>

                                <div className="w-96">
                                    <label>Jenis File Eksport</label>
                                    <Select
                                        inputId="ddlfiletype"
                                        components={animatedComponents}
                                        value={this.state.fileType.value}
                                        placeholder="Pilih Jenis File Eksport"
                                        options={this.state.fileType.data}
                                        onChange={this.handleChangeFileType}
                                    />
                                </div>

                                <div className="space-x-5 flex items-end pb-3">
                                    <div className="w-96">
                                        <label>Kirim Email</label>
                                        <CreatableSelect
                                            inputId="tslemailto"
                                            placeholder="Ketik Email"
                                            components={{ IndicatorSeparator: () => null, DropdownIndicator: () => null }}
                                            className="w-full"
                                            isMulti
                                            isClearable
                                            menuIsOpen={false}
                                            inputValue={this.state.email.tempValue}
                                            onChange={(e) => this.setState({ email: { ...this.state.email, value: e } })}
                                            onInputChange={this.handleChangeEmail}
                                            onKeyDown={this.handleKeyDown}
                                            value={this.state.email.value}
                                        />
                                    </div>
                                    <CheckPermissionComponent permissionConstant={[EXPORT_TICKET_INSERT]} userPermission={this.props.userDetail.permissions}>
                                        <button id="btnexportfile" className="flex items-center cursor-pointer bg-olddarkblue text-white px-6 rounded min-h-38" onClick={() => this.setState({ showConfirmAlertExportTicket: true })}>
                                            <span className="ml-1">Eksport Tiket</span>
                                        </button>
                                    </CheckPermissionComponent>
                                </div>
                            </div>

                            {/* Results */}
                            <div className={this.state.page === "3" ? "font-bold h-5/6 w-4/5" : "hidden"}>
                                <TableNexcare
                                    column={this.state.columns}
                                    dataTable={this.state.listReportResult}
                                    pagination={this.state.pagination}
                                    onPage={this.handleSelectedPage}
                                    onPageSize={this.handleSelectedPageSize}
                                />
                            </div>

                            <Alert show={this.state.showConfirmAlertDownload} icon="warning" button={true} title="Apakah Anda yakin mengunduh file ini?" close={() => this.setState({ showConfirmAlertDownload: false })} submit={() => this.handleReportRequest("reportdownload")} />
                            <Alert show={this.state.showConfirmAlertEmail} icon="warning" button={true} title="Apakah Anda yakin mengirimkan email ini?" close={() => this.setState({ showConfirmAlertEmail: false })} submit={() => this.handleReportRequest("reportemail")} />
                            <Alert show={this.state.showSuccessAlert} icon="success" title="Data berhasil diproses!" />
                            <Alert show={this.state.showErrorAlert} icon="warning" title="Nama principal tidak boleh kosong!" close={() => this.setState({ showErrorAlert: false })} ok />
                            <Alert show={this.state.showErrorAlertResponse} icon="warning" title={this.state.errorMessage} close={() => this.setState({ showErrorAlertResponse: false })} ok />
                            <Alert show={this.state.showConfirmAlertSaveNewProfile} button={true} title="Simpan Profile Baru" desc={this.saveNewProfileDescription()} close={() => this.setState({ showConfirmAlertSaveNewProfile: false, profileName: '', showAlertProfileNameBlank: false, showAlertProfileNameExist: false })} submit={() => this.validationProfileName()} />
                            <Alert show={this.state.showConfirmAlertSaveProfile} button={true} title="Simpan Data" desc="Apakah Anda yakin ingin menyimpan profile ini" close={() => this.setState({ showConfirmAlertSaveProfile: false, profileName: '', showAlertProfileNameBlank: false, showAlertProfileNameExist: false })} submit={() => this.saveNewProfile()} />
                            <Alert show={this.state.showSuccessAlertSaveProfile} icon="success" title="Berhasil" desc={"Data berhasil disimpan"} close={() => this.setState({ showSuccessAlertSaveProfile: false })} ok />
                            <Alert show={this.state.showConfirmAlertUpdateSaveProfile} button={true} title="Simpan Perubahan Data" desc="Apakah Anda yakin ingin menyimpan perubahan profile ini" close={() => this.setState({ showConfirmAlertUpdateSaveProfile: false })} submit={() => this.updateProfile()} />
                            <Alert show={this.state.showSuccessAlertUpdateSaveProfile} icon="success" title="Berhasil" desc={"Data berhasil diubah"} close={() => this.setState({ showSuccessAlertUpdateSaveProfile: false })} ok />
                            <Alert show={this.state.showConfirmAlertExportTicket} icon="warning" button={true} title="Apakah Anda yakin ingin melakukan eksport tiket?" close={() => this.setState({ showConfirmAlertExportTicket: false })} submit={() => this.handleExportTicket()} />
                            <Alert show={this.state.showErrorAlertEmptyColumn} icon="warning" title="Kolom untuk Dieksport tidak boleh kosong!" close={() => this.setState({ showErrorAlertEmptyColumn: false })} ok />
                        </div>
                    </div>
                </div>
            </CheckPermissionComponent>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        token: state.authentication.token,
        userDetail: state.authentication.userDetail
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        handleLogout: () => dispatch({ type: ActionType.IS_LOGOUT })
    };
};


export default connect(mapStateToProps, mapDispatchToProps)(ExportTicket);